/**
 * Palette for GiftedChat. Prefer CSS variables so embedded hosts can theme
 * via `.idigest-chat` (see theme.ts / shellTheme.css). Fallbacks keep
 * WebIDigestApp light appearance when vars are unset.
 *
 * Use `white` / `black` only for literal on-accent text or shadows.
 * Use `canvas` / `text` / bubble tokens for themeable surfaces.
 */
const global = {
  defaultColor: 'var(--idigest-chat-muted, #b2b2b2)',
  backgroundTransparent: 'transparent',
  defaultBlue: '#0084ff',
  leftBubbleBackground: 'var(--idigest-chat-bubble-left, #ffffff)',
  rightBubbleBackground: 'var(--idigest-chat-bubble-right, #e0e0e0)',
  bubbleBorder: 'var(--idigest-chat-bubble-border, #aaaaaa)',
  canvas: 'var(--idigest-chat-bg, #ffffff)',
  surface: 'var(--idigest-chat-surface, #f5f5f5)',
  text: 'var(--idigest-chat-fg, #000000)',
  inputBg: 'var(--idigest-chat-input-bg, #ffffff)',
  inputBorder: 'var(--idigest-chat-input-border, #d0d0d0)',
  voiceIdle: 'var(--idigest-chat-voice-idle, #e0e0e0)',
  voiceActive: 'var(--idigest-chat-voice-active, #ffffff)',
  quoteBg: 'var(--idigest-chat-quote-bg, #888888)',
  black: '#000',
  white: '#fff',
  carrot: '#e67e22',
  emerald: '#2ecc71',
  peterRiver: '#3498db',
  wisteria: '#8e44ad',
  alizarin: '#e74c3c',
  turquoise: '#1abc9c',
  midnightBlue: '#2c3e50',
  optionTintColor: '#007AFF',
  timeTextColor: 'var(--idigest-chat-muted, #aaa)'
};

export default global;
